/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/flux/entity'


export default class extends Entity
{
  constructor(location, hierarchy)
  {
    // No dependences since otherwise we would need to re-upcast all models each time a dependency changes (expensive !).
    // Use flux/cache(...objects) instead with equals, less defined for complex objects.
    super([]);

    this.location = location;

    this.hierarchy = new hierarchy();
  }


  getLocation ()
  {
    return this.location;
  }


  getHierarchy ()
  {
    return this.hierarchy;
  }


}
